
import Vue from "vue";
import {BrowseStateBase} from "@/utils/browse/browse-state-base";
import {AuthService, BookYearService} from "@/services";
import {UserConfigService} from "@/services/user-config-service";

export default Vue.extend({
	data(){
		return {
			childOrigin: "",
			resizing: false,
			dragWidth: 0
		};
	},
	props: {
		state: {
			type: Object as () => BrowseStateBase,
			required: true
		}
	},
	computed: {
		isLeft():boolean{
			return this.state.inlineIframeButton?.IframePosition === "left";
		},
		isVariable():boolean{
			return this.state.inlineIframeButton?.IframeWidthMode === 2;
		},
		title():string{
			if (!this.state.inlineIframeButton) return "";
			return this.state.inlineIframeButton.Title || this.state.inlineIframeButton.Name;
		},
		panelStyle():any{
			let btn = this.state.inlineIframeButton;
			if (!btn) return {};
			let style:any = {flexShrink: 0};
			if (this.resizing || (this.isVariable && this.dragWidth > 0)) {
				style.width = `${this.dragWidth}px`;
			} else if (btn.IframeWidthMode === 1) {
				style.width = `${btn.IframePercentWidth}%`;
			} else {
				let width = btn.IframeFixedWidth || 400;
				style.width = `${width}px`;
			}
			if (btn.IframePosition === "left") {
				style.marginRight = "5px";
			} else {
				style.marginLeft = "5px";
			}
			return style;
		}
	},
	watch: {
		"state.selectedItems"(items: any[]){
			if (!this.childOrigin) return;
			let frame = this.$refs.frame as HTMLIFrameElement;
			if (frame) {
				frame.contentWindow?.postMessage({type: "SELECTION_CHANGED", items}, this.childOrigin);
			}
		}
	},
	methods: {
		close(){
			this.state.closeInlineIframe();
		},
		async saveWidth(){
			if (!this.state.inlineIframeButton || this.dragWidth <= 0) return;
			let btn = this.state.inlineIframeButton;
			btn.IframeFixedWidth = this.dragWidth;
			let buttons = UserConfigService.getCustomButtons() as any;
			let browseButtons = buttons["Browse" + this.state.browse.ID] || [];
			let index = browseButtons.findIndex((b: any) => b.ID === btn.ID);
			if (index >= 0) {
				browseButtons[index].IframeFixedWidth = this.dragWidth;
				await UserConfigService.setCustomButtonSettings(buttons);
			}
		},
		onResizeStart(e: MouseEvent){
			if (!this.isVariable) return;
			e.preventDefault();
			this.resizing = true;
			let startX = e.clientX;
			let startWidth = (this.$el as HTMLElement).offsetWidth;

			const onMouseMove = (e: MouseEvent) => {
				let delta = e.clientX - startX;
				if (this.isLeft) {
					this.dragWidth = Math.max(200, startWidth + delta);
				} else {
					this.dragWidth = Math.max(200, startWidth - delta);
				}
			};

			const onMouseUp = () => {
				this.resizing = false;
				this.saveWidth();
				window.removeEventListener("mousemove", onMouseMove);
				window.removeEventListener("mouseup", onMouseUp);
			};

			window.addEventListener("mousemove", onMouseMove);
			window.addEventListener("mouseup", onMouseUp);
		},
		sendAppData(frame: HTMLIFrameElement) {
			if (!this.childOrigin) return;
			let app = {
				bookyear: BookYearService.selectedBookYear,
				dossier: AuthService.wfDossier.id,
				userId: AuthService.wfUser.ID,
				accessToken: AuthService.tokenStore.getSelectedToken().token,
				socketId: AuthService.tokenStore.socketId
			};
			frame.contentWindow?.postMessage({data: this.state.inlineIframeModel, app, selectedItems: this.state.selectedItems}, this.childOrigin);
		},
		async onMessage(e: MessageEvent){
			if (e.data?.type === "IFRAME_READY") {
				this.childOrigin = e.origin;
				let frame = this.$refs.frame as HTMLIFrameElement;
				if (frame) {
					setTimeout(() => {
						this.sendAppData(frame);
					}, 150);
				}
			}

			if (e.data?.type === "REQUEST_TOKEN") {
				await AuthService.refreshTokensIfRequired();
				let frame = this.$refs.frame as HTMLIFrameElement;
				if (frame) {
					this.sendAppData(frame);
				}
			}

			if (e.data?.type === "IFRAME_UPDATE") {
				this.$emit("update-parent", e.data?.data);
			}

			if (e.data?.type === "CLEAR_SELECTION") {
				this.state.selectedItems.splice(0, this.state.selectedItems.length);
			}

			if (e.data?.type === "CLOSE_MODAL") {
				this.close();
			}
		}
	},
	mounted(){
		window.addEventListener("message", this.onMessage);
		if (this.isVariable) {
			this.dragWidth = (this.$el as HTMLElement).offsetWidth || 400;
		}
	},
	beforeDestroy(){
		window.removeEventListener("message", this.onMessage);
	}
});
